import { css } from "@emotion/react";

export const main = css`
  flex-grow: 1;
  width: 90%;
  max-width: 1012px;
  margin: 0 auto;
`;
